import React from 'react';
import { Alert, Box, Stack, Typography } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { CancelButton, DeleteButton } from '../../../components/mui/Buttons/Buttons';
import useHandleApiResponse from '../../../Hooks/useHandleApiResponse';
import { deleteWebinar } from '../../../redux/features/webinarSlice';

// Soft delete confirmation. Delete is irreversible via the API (no undelete),
// so we confirm before firing.
const DeleteWebinar = ({ row, onClose }) => {
  const dispatch = useDispatch();
  const { mutating } = useSelector((state) => state.webinar);
  const handleApiResponse = useHandleApiResponse();

  const handleDelete = async () => {
    const res = await dispatch(deleteWebinar(row.webinar_id));
    handleApiResponse(res, {
      onSuccess: () => {
        if (onClose) onClose(true); // refetch the table
      },
    });
  };

  return (
    <Box sx={{ mt: 1 }}>
      <Typography variant="body1">
        Are you sure you want to delete the webinar <strong>{row?.webinar_name}</strong>? This cannot
        be undone.
      </Typography>

      {/* Deleting the active webinar takes the public site down to "no webinar" —
          say so before it happens rather than after. */}
      {row?.is_active && (
        <Alert severity="warning" sx={{ mt: 2, py: 0.5 }}>
          This is the active webinar. Deleting it leaves no active webinar, and the public webinar
          site will show none until another one is activated.
        </Alert>
      )}

      <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 3 }}>
        <Stack direction="row" spacing={1}>
          <CancelButton action={() => onClose && onClose(false)}>Cancel</CancelButton>
          <DeleteButton action={handleDelete} disabled={mutating}>
            {mutating ? 'Deleting...' : 'Delete'}
          </DeleteButton>
        </Stack>
      </Box>
    </Box>
  );
};

export default DeleteWebinar;
